import { render } from "./DraggableSelectDemo.vue?vue&type=template&id=659eb17b"
import script from "./DraggableSelectDemo.vue?vue&type=script&lang=ts"
export * from "./DraggableSelectDemo.vue?vue&type=script&lang=ts"
script.render = render

export default script